// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-author-template-js": () => import("./../../../src/templates/AuthorTemplate.js" /* webpackChunkName: "component---src-templates-author-template-js" */),
  "component---src-templates-chapter-template-js": () => import("./../../../src/templates/ChapterTemplate.js" /* webpackChunkName: "component---src-templates-chapter-template-js" */),
  "component---src-templates-single-book-template-js": () => import("./../../../src/templates/SingleBookTemplate.js" /* webpackChunkName: "component---src-templates-single-book-template-js" */)
}

